import { DEVELOPER, BUSINESS } from '@/constants/memberList';

const Staff = () => {
  return (
    <div className='flex flex-col gap-4 xl:gap-4 md:gap-6'>
      <div className='flex flex-col gap-2'>
        <p className='md:text-xl text-base font-semibold text-[#C6C6C6]'>
          SW Development
        </p>
        <div className='w-full grid grid-cols-2 md:grid-cols-4 xl:grid-cols-6 gap-2 md:gap-3 justify-start'>
          {DEVELOPER.map((member, index) => (
            <div key={index} className='flex flex-col'>
              <div className='w-40 md:w-40 xl:w-40 h-52 md:h-56 xl:h-56 bg-gray-200 overflow-hidden'>
                <img
                  src={member.img}
                  alt={member.name}
                  className='w-full h-full object-cover grayscale'
                />
              </div>
              <div className='w-40 md:w-40 xl:w-40 min-h-20 flex flex-col items-start bg-[#262626] px-2 py-2'>
                <h3 className='text-white font-bold text-sm'>{member.name}</h3>
                <p className='text-[#b2b2b2] text-sm'>{member.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className='flex flex-col gap-2'>
        <p className='md:text-xl text-base font-semibold text-[#C6C6C6]'>
          Business
        </p>
        <div className='w-full grid grid-cols-2 md:grid-cols-4 xl:grid-cols-6 gap-2 md:gap-3 justify-start'>
          {BUSINESS.map((member, index) => (
            <div key={index} className='flex flex-col'>
              <div className='w-40 md:w-40 xl:w-40 h-52 md:h-56 xl:h-56 bg-gray-200 overflow-hidden'>
                <img
                  src={member.img}
                  alt={member.name}
                  className='w-full h-full object-cover grayscale'
                />
              </div>
              <div className='w-40 md:w-40 xl:w-40 min-h-20 flex flex-col items-start bg-[#262626] px-2 py-2'>
                <h3 className='text-white font-bold text-sm'>{member.name}</h3>
                <p className='text-[#b2b2b2] text-sm'>{member.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Staff;
